export function getMinMaxXY(info) {
    const min = [];
    const max = [];
    for (let i = 0; i < info.baseFrequency.length; i++) {
        const baseFrequency = info.baseFrequency[i];
        const frequencyOffset = info.frequencyOffset[i];
        const spectralWidth = info.spectralWidth[i];
        const offset = frequencyOffset / baseFrequency;
        min.push(offset - spectralWidth * 0.5);
        max.push(offset + spectralWidth * 0.5);
    }
    return {
        minX: min[0],
        maxX: max[0],
        minY: min[1],
        maxY: max[1],
    };
}
//# sourceMappingURL=getMinMaxXY.js.map